import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text } from '@radix-ui/themes';
import { useStackModal } from '@rango-dev/internal-profile/hooks';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../hooks/useProfile';
import { ProfileWallets } from '../ProfileWallets';
import { ConnectedWallets } from '../ProfileWallets/ConnectedWallets';
export function ProfileWalletsModal(props) {
    const { indexInStack = 0, setShouldOpenConnectWalletsModal, onLogin, onMerge, onError } = props;
    const { data, renderHeader } = props;
    const { t } = useTranslation();
    const { compatibleAccounts } = useProfile();
    const { pop } = useStackModal();
    return (_jsxs(Flex, { direction: "column", height: "100%", overflow: "clip", children: [renderHeader({
                showBackButton: indexInStack > 0,
                handleClose: () => {
                    pop();
                },
            }), _jsxs(Flex, { direction: "column", gap: "5", p: "4", flexGrow: "1", minHeight: "0", children: [_jsx(Text, { size: "2", color: "gray", align: "left", children: data.isUserLoggedIn
                            ? t('Link your wallets to your profile to increase your score.')
                            : t('Use your wallet to login into your profile.') }), data.isUserLoggedIn ? (_jsx(ProfileWallets, { data: data, onLogin: onLogin, onMerge: onMerge, onError: onError, setShouldOpenConnectWalletsModal: setShouldOpenConnectWalletsModal })) : (_jsx(ConnectedWallets, { accounts: compatibleAccounts, setShouldOpenConnectWalletsModal: setShouldOpenConnectWalletsModal, data: data, onLogin: onLogin, onMerge: onMerge, onError: onError }))] })] }));
}
